var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3409_3313)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3409_3313)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.4993 34.7727C29.2773 34.7727 34.772 29.2781 34.772 22.5C34.772 15.722 29.2773 10.2273 22.4993 10.2273C15.7212 10.2273 10.2266 15.722 10.2266 22.5C10.2266 29.2781 15.7212 34.7727 22.4993 34.7727Z",
    stroke: "white",
    strokeWidth: 1.43182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.5009 29.6591C26.4547 29.6591 29.66 26.4539 29.66 22.5C29.66 18.5462 26.4547 15.3409 22.5009 15.3409C18.547 15.3409 15.3418 18.5462 15.3418 22.5C15.3418 26.4539 18.547 29.6591 22.5009 29.6591Z",
    stroke: "white",
    strokeWidth: 1.43182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.5005 24.5455C23.6302 24.5455 24.546 23.6297 24.546 22.5C24.546 21.3704 23.6302 20.4546 22.5005 20.4546C21.3709 20.4546 20.4551 21.3704 20.4551 22.5C20.4551 23.6297 21.3709 24.5455 22.5005 24.5455Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3409_3313)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3409_3313)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.9192 34.5728C29.6973 34.5728 35.1919 29.0781 35.1919 22.3001C35.1919 15.522 29.6973 10.0273 22.9192 10.0273C16.1412 10.0273 10.6465 15.522 10.6465 22.3001C10.6465 29.0781 16.1412 34.5728 22.9192 34.5728Z",
    stroke: "white",
    strokeWidth: 1.43182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.9208 29.4592C26.8747 29.4592 30.0799 26.2539 30.0799 22.3001C30.0799 18.3462 26.8747 15.141 22.9208 15.141C18.967 15.141 15.7617 18.3462 15.7617 22.3001C15.7617 26.2539 18.967 29.4592 22.9208 29.4592Z",
    stroke: "white",
    strokeWidth: 1.43182,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3409_3313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9205 24.3455C24.0501 24.3455 24.9659 23.4298 24.9659 22.3001C24.9659 21.1704 24.0501 20.2546 22.9205 20.2546C21.7908 20.2546 20.875 21.1704 20.875 22.3001C20.875 23.4298 21.7908 24.3455 22.9205 24.3455Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3409_3313",
    x: 16.7841,
    y: 16.1637,
    width: 12.2736,
    height: 12.2726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.04545
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.870588 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3409_3313"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3409_3313",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3409_3313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3409_3313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3409_3313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.419922 -0.199951)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3409_3313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.419922 -0.199951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.2de4c7ef37ac6212b85973ad7bd1419d.svg";
export { ForwardRef as ReactComponent };